import { useCallback, useEffect, useState } from 'react';
import api from '../../../lib/axios';

const PATH = 'api/v1/kb';

export function useKnowledgeBase() {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await api.get(`${PATH}/docs`);
      setDocs(r.data.docs || []);
    } catch (err) {
      console.error('KB list failed:', err);
      setError(err?.response?.data?.detail || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const uploadFile = useCallback(async (file, name) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('name', name || file.name);
    const r = await api.post(`${PATH}/docs`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    await refresh();
    return r.data;
  }, [refresh]);

  const uploadUrl = useCallback(async (url, name) => {
    const r = await api.post(`${PATH}/docs-url`, { url, name });
    await refresh();
    return r.data;
  }, [refresh]);

  const remove = useCallback(async (id) => {
    await api.delete(`${PATH}/docs/${id}`);
    await refresh();
  }, [refresh]);

  const retry = useCallback(async (id) => {
    await api.post(`${PATH}/docs/${id}/retry`);
    await refresh();
  }, [refresh]);

  return { docs, loading, error, refresh, uploadFile, uploadUrl, remove, retry };
}
